import { render } from "./Additinal.vue?vue&type=template&id=8a1605cc&scoped=true"
import script from "./Additinal.vue?vue&type=script&lang=js"
export * from "./Additinal.vue?vue&type=script&lang=js"

import "./Additinal.vue?vue&type=style&index=0&id=8a1605cc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a1605cc"]])

export default __exports__